import {translation} from "@2d-front-monorepo/core";
import {JSX, memo} from "react";
import {approvalStatusLabel, approvalStatusName} from "../helpers/enumNaming";
import {PermitEntityResult} from "../index";

function EntityHistoryStatusComponent<T>({status}: { status: PermitEntityResult<T> | undefined }): JSX.Element | undefined {
	if (status == null) {
		return undefined;
	}
	const pillClass = `pill__entity-history--${approvalStatusName(status)}`;
	return (<div className={`pill ${pillClass} pill--small`}>{translation(approvalStatusLabel(status))}</div>);
}

const MemoizedEntityHistoryStatusComponent = memo(EntityHistoryStatusComponent) as <T>(props: { status: PermitEntityResult<T> | undefined }) => JSX.Element | undefined;
export default MemoizedEntityHistoryStatusComponent;
